<template>
  <div class="identity-verification">
    <!-- 详情头 -->
    <a-space align="center">
      <a-icon type="left" style="font-size: 23px" @click="changeToInfoDetail" />
      <div
        class="ant-descriptions-title"
        style="font-size: 16px; margin-bottom: 0px"
      >
        身份认证
      </div>
    </a-space>
    <!-- 详情头 -->
    <!-- 步骤条 -->
    <a-steps
      :current="currentStep"
      style="margin-bottom: 30px; margin-top: 20px"
    >
      <a-step title="居民身份证" />
      <a-step title="本人操作" />
      <a-step title="认证成功" />
    </a-steps>

    <!-- 主体内容 -->
    <div v-if="currentStep === 0">
      <div class="verification-content" style="margin-top: 40px">
        <div class="left-section">
          <!-- <a-row type="flex" justify="space-around" align="middle"> -->
          <!-- <a-col :span="12"> -->
          <div class="upload-item" style="height: 180px">
            <div class="upload-box">
              <a-icon type="plus-circle" class="upload-icon" />
              <span>请上传身份证正面</span>
            </div>

            <div class="clearfix">
              <a-upload
                action="https://api.jssyjt.net/external-service-center/baiduRecognize/idCard"
                :headers="uploadHeaders"
                list-type="picture-card"
                :file-list="idCardFront"
                @preview="handlePreview"
                @change="handleIdCardFrontChange"
                :multiple="false"
                :show-upload-list="true"
                accept=".jpg,.png"
                :data="{ idCardSide: 'front' }"
              >
                <div v-if="idCardFront.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">请上传图片</div>
                </div>
              </a-upload>
              <a-modal
                :visible="previewVisible"
                :footer="null"
                @cancel="previewHandleCancel"
              >
                <img alt="身份证正面" style="width: 100%" :src="previewImage" />
              </a-modal>
            </div>
          </div>

          <div class="upload-item">
            <div class="upload-box">
              <a-icon type="plus-circle" class="upload-icon" />
              <span>请上传身份证反面</span>
            </div>
            <div class="clearfix">
              <a-upload
                action="https://api.jssyjt.net/external-service-center/baiduRecognize/idCard"
                :headers="uploadHeaders"
                list-type="picture-card"
                :file-list="idCardBack"
                @preview="handlePreview"
                @change="handleIdCardBackChange"
                :multiple="false"
                :show-upload-list="true"
                accept=".jpg,.png"
                :data="{ idCardSide: 'back' }"
              >
                <div v-if="idCardBack.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">请上传图片</div>
                </div>
              </a-upload>
              <a-modal
                :visible="previewVisible"
                :footer="null"
                @cancel="previewHandleCancel"
              >
                <img alt="身份反面" style="width: 100%" :src="previewImage" />
              </a-modal>
            </div>
          </div>
        </div>

        <!-- 分割线 -->
        <div class="vertical-divider"></div>

        <div class="right-section">
          <div class="personal-info">
            <div class="info-item">
              <span class="label">姓名：</span>
              <span>{{ front.certName }}</span>
            </div>
            <div class="info-item">
              <span class="label">身份证号：</span>
              <span>{{ front.certNum }}</span>
            </div>
            <div class="info-item">
              <span class="label">性别：</span>
              <span>{{ front.sex }}</span>
            </div>
            <div class="info-item">
              <span class="label">出生日期：</span>
              <span>{{ front.birthday }}</span>
            </div>
            <div class="info-item">
              <span class="label">民族：</span>
              <span>{{ front.nationality }}</span>
            </div>
            <div class="info-item">
              <span class="label">住址：</span>
              <span>{{ front.certAddress }}</span>
            </div>

            <div class="info-item">
              <span class="label">身份证有效期：</span>
              <span>{{ back.certEfffromDate }}-{{ back.certEffToDate }}</span>
            </div>
          </div>
          <div class="error-msg" style="margin-top: 15px">
            <span
              >通过身份证自动获取身份信息，请检查身份证信息是否正确，如有错误，请重新上传图片。</span
            >
          </div>
        </div>
      </div>
      <div class="action-buttons">
        <a-button
          @click="CertnextStep"
          type="primary"
          size="large"
          :loading="state.loginBtn"
          >下一步</a-button
        >
      </div>
    </div>

    <!-- 第二部分：二维码验证 -->
    <div v-if="currentStep === 1">
      <div class="step-2">
        <div class="qr-section">
          <p class="qr-text">
            请用微信扫描下方二维码，完成身份验证，身份验证通过后即可进行下一步
          </p>
          <div class="qr-code">
            <img
              :src="qrCodeFaceId"
              alt="QR Code"
              style="width: 150px; height: 150px"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="currentStep === 2">
      <a-result
        status="success"
        title="人脸核身成功"
        sub-title="您的身份信息已通过系统校验，并完成身份认证，请点击下方【返回】按钮，返回业务页面继续后续操作"
      >
        <template #extra>
          <a-button @click="changeToInfoDetail"> 返回 </a-button>
        </template>
      </a-result>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import storage from "store";
import { creatTencentFaceId } from "@/api/user/personalCenter/PersonalCenter.js";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  computed: {
    uploadHeaders() {
      const token = storage.get(ACCESS_TOKEN);
      return {
        Authorization: token ? token : "",
      };
    },
  },

  watch: {
    currentStep(newVal, oldVal) {
      if (newVal === 1 && oldVal === 0) {
        console.log("[WS] step=1，建立连接");
        this.connectFaceIdWebSocket(this.websocketUid);
      } else {
        console.log("[WS] 离开 step=1，关闭连接");
        this.closeWebSocket();
      }
    },
  },

  data() {
    return {
      currentStep: 0, // 当前步骤
      idCardFront: [],
      idCardBack: [],
      previewVisible: false,
      previewImage: "",

      qrCodeFaceId: "",
      websocket: null,
      websocketUid: "",
      wsConnected: false,

      front: {
        certName: "",
        certNum: "",
        sex: "",
        birthday: "",
        nationality: "",
        certAddress: "",
      },

      back: {
        certEfffromDate: "",
        certEffToDate: "",
      },
      state: {
        loginBtn: false,
      },
    };
  },
  mounted() {},
  methods: {
    connectFaceIdWebSocket(uid) {
      if (!uid) return;
      // 防止重复连接
      // this.closeWebSocket();
      if (this.websocket) {
        console.warn("WS 已存在，跳过重复连接");
        return;
      }

      const wsUrl = `wss://api.jssyjt.net/common-websocket/tencentFaceIdServer/${uid}`;
      this.websocket = new WebSocket(wsUrl);

      this.websocket.onopen = () => {
        console.log("[WS] 连接成功 uid =", uid);
        this.startHeartbeat();
      };

      this.websocket.onmessage = (event) => {
        this.handleFaceIdMessage(event.data);
      };

      this.websocket.onerror = (err) => {
        console.error("[WS] 连接异常", err);
      };

      this.websocket.onclose = (e) => {
        console.log("[WS] onclose", e.code, e.reason, Date.now());
        this.stopHeartbeat();
      };
    },

    startHeartbeat() {
      this.stopHeartbeat();

      this.wsHeartbeatTimer = setInterval(() => {
        if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
          this.websocket.send("ping");
          console.log("[WS] ping");
        }
      }, 10000);
    },

    stopHeartbeat() {
      if (this.wsHeartbeatTimer) {
        clearInterval(this.wsHeartbeatTimer);
        this.wsHeartbeatTimer = null;
      }
    },

    handleFaceIdMessage(message) {
      // 1️⃣ 业务成功信号（后端约定）
      if (message === "核身完成") {
        setTimeout(() => {
          this.$notification.success({
            message: "核身成功",
            description: "身份核验已通过",
          });
        }, 300);

        this.closeWebSocket();
        this.currentStep++;
        return;
      }

      // 2️⃣ 心跳 / 连接类消息 —— 直接忽略
      if (message === "pong" || message === "ping") {
        return;
      }

      // 3️⃣ 其他 JSON 控制消息（如 WS_CONNECTED）
      if (typeof message === "string" && message.startsWith("{")) {
        try {
          const data = JSON.parse(message);
          console.log("[WS] 控制消息：", data);
          return;
        } catch (e) {
          // 不是合法 JSON，直接忽略
          return;
        }
      }

      // 4️⃣ 未知消息兜底（不关闭连接）
      console.warn("[WS] 未处理的 WS 消息：", message);
    },

    closeWebSocket() {
      this.stopHeartbeat();

      if (this.websocket) {
        this.websocket.close();
        this.websocket = null;
      }
    },

    changeToInfoDetail() {
      this.closeWebSocket();
      this.$emit("changeToInfoDetail");
    },

    //预览
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    //身份证正面照图片变更
    handleIdCardFrontChange({ fileList }) {
      fileList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            this.front.certName = item.response.data.idCardFrontData.certName;
            this.front.certNum = item.response.data.idCardFrontData.certNum;
            this.front.sex = item.response.data.idCardFrontData.sex;
            this.front.birthday = item.response.data.idCardFrontData.birthday;
            this.front.certAddress =
              item.response.data.idCardFrontData.certAddress;
            this.front.nationality =
              item.response.data.idCardFrontData.nationality;
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data.idCardFrontOssUrl,
            };
          }
          if (item.response.code == "400") {
            setTimeout(() => {
              this.$notification["error"]({
                message: "错误",
                description: (item.response || {}).data || {},
                duration: 4,
              });
            }, 300);

            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          }
        } else {
          return item;
        }
      });
      this.idCardFront = fileList;
    },

    //身份证反面照图片变更
    handleIdCardBackChange({ fileList }) {
      fileList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            this.back.certEfffromDate =
              item.response.data.idCardBackData.certEfffromDate;
            this.back.certEffToDate =
              item.response.data.idCardBackData.certEffToDate;
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data.idCardBackOssUrl,
            };
          }
          if (item.response.code == "400") {
            setTimeout(() => {
              this.$notification["error"]({
                message: "错误",
                description: (item.response || {}).data || {},
                duration: 4,
              });
            }, 300);
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          }
        } else {
          return item;
        }
      });
      this.idCardBack = fileList;
    },

    previewHandleCancel() {
      this.previewVisible = false;
    },

    CertnextStep() {
      if (
        this.idCardFront.length > 0 &&
        this.idCardFront.every((f) => f.status === "done") &&
        this.idCardBack.length > 0 &&
        this.idCardBack.every((f) => f.status === "done")
      ) {
        this.state.loginBtn = true;
        creatTencentFaceId({
          ruleId: "4",
          idCard: this.front.certNum,
          name: this.front.certName,
        })
          .then((res) => {
            if (res && res.code === "200") {
              const result = res.data;
              QRCode.toDataURL(result.url).then((res) => {
                this.qrCodeFaceId = res;
              });
              this.websocketUid = result.uid;
              this.state.loginBtn = false;
              this.currentStep++;
            } else {
              if (item.response.code == "400") {
                setTimeout(() => {
                  this.$notification["error"]({
                    message: "错误",
                    description: (item.response || {}).data || {},
                    duration: 4,
                  });
                }, 300);
                this.state.loginBtn = false;
              }
            }
          })
          .catch((err) => {
            console.error("接口调用异常：", err);
          });
      } else {
        setTimeout(() => {
          this.$notification["error"]({
            message: "错误",
            description: "请按要求上传身份证正反面",
            duration: 4,
          });
        }, 300);
      }
    },

    nextStep() {
      if (this.currentStep < 2) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
  },
};
</script>

<style scoped>
.identity-verification {
  padding: 20px;
}

.verification-content {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.qr-section {
  text-align: center;
}

.left-section {
  width: 48%;
}
.right-section {
  width: 48%;
}

.vertical-divider {
  width: 1px;
  background-color: #e8e8e8;
  margin: 0 20px;
}

.upload-item {
  margin-bottom: 20px;
}

.upload-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.upload-icon {
  font-size: 24px;
  color: #1890ff;
  margin-right: 10px;
}

.upload-btn {
  margin-top: 10px;
}

.personal-info {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
}

.info-item {
  display: flex;
  margin-bottom: 24px;
}

.label {
  font-weight: bold;
  margin-right: 10px;
}

.error-msg {
  color: red;
  font-size: 12px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
